import * as React from "react";
import { UitkHeading, UitkHeadingProps } from "uitk-react-text";
import { useLocalization } from "@shared-ui/localization-context";
import { TripAttachQualificationViewProps } from "./typings";
import { TripCard } from "./components/TripCard";
import { AttachSavingsCard } from "./components/AttachSavingsCard";
import { locKeys } from "./l10n";
import {
  PageBackgroundContext,
  BackgroundColorTokens,
} from "src/components/flexComponents/PageLevelProviders/PageBackgroundColor/PageBackgroundContext.tsx";

export const TripAttachQualificationView = (props: TripAttachQualificationViewProps) => {
  const { formatText } = useLocalization();
  const headingConfig: UitkHeadingProps = { level: 2, size: 700 };

  const backgroundColor = React.useContext(PageBackgroundContext);
  const withBorder = backgroundColor === BackgroundColorTokens.BACKGROUND_WHITE;

  return (
    <div className="TripAttachQualification uitk-grid all-y-gutter-three all-x-gutter-three uitk-cell all-cell-1-1 all-b-margin-six">
      <div className="uitk-cell all-cell-1-1 all-t-margin-three">
        <UitkHeading {...headingConfig}>{formatText(locKeys.moduleTitle)}</UitkHeading>
      </div>
      <div className="uitk-cell s-cell-1-1 all-cell-1-2 uitk-grid">
        <div className="uitk-flex uitk-flex-grow-1">
          <TripCard
            destinationName={props.destinationName}
            imageData={props.imageData}
            moduleName={props.moduleName}
            tripEndDate={props.tripEndDate}
            tripStartDate={props.tripStartDate}
            withBorder={withBorder}
          />
        </div>
      </div>
      <div className="uitk-cell s-cell-1-1 all-cell-1-2 uitk-grid">
        <div className="uitk-flex uitk-flex-grow-1">
          <AttachSavingsCard
            deepLink={props.deepLink}
            deepLinkMipType={props.deepLinkMipType}
            moduleName={props.moduleName}
            percentageOff={props.percentageOff}
            withBorder={withBorder}
          />
        </div>
      </div>
    </div>
  );
};

export default TripAttachQualificationView;
